import { render, staticRenderFns } from "./LessonDealsLibrary.vue?vue&type=template&id=72f3877d&scoped=true&"
import script from "./LessonDealsLibrary.vue?vue&type=script&lang=js&"
export * from "./LessonDealsLibrary.vue?vue&type=script&lang=js&"
import style0 from "./LessonDealsLibrary.vue?vue&type=style&index=0&id=72f3877d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f3877d",
  null
  
)

export default component.exports